<script setup lang="ts">
</script>

<template>
  <div class="playing-icon">
    <span />
    <span />
    <span />

  </div>
</template>

<style scoped lang="postcss"></style>
